"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDefaultProps = exports.GKPureComponent = void 0;
var React = __importStar(require("react"));
var services_1 = require("../services");
var GKPureComponent = /** @class */ (function (_super) {
    __extends(GKPureComponent, _super);
    function GKPureComponent(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Combine new class name(s) with classes from this.props
         */
        _this.mergeClasses = function () {
            var newClasses = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                newClasses[_i] = arguments[_i];
            }
            return __spreadArray(__spreadArray([], newClasses, true), [_this.props.className], false).filter(function (c) { return c; }).join(" ");
        };
        /**
         * Combine new style object with this.style
         */
        _this.mergeStyles = function (newStyles) {
            return _this.props.style && newStyles
                ? Object.assign({}, _this.props.style, newStyles)
                : newStyles;
        };
        /**
         * Directly set the uniqueId
         */
        _this.setUniqueId = function (id) {
            _this.pvtUniqueId = id;
        };
        return _this;
    }
    Object.defineProperty(GKPureComponent.prototype, "uniqueId", {
        /**  Get the unique id for this component. Will be generated if an id is not passed */
        get: function () {
            if (!this.pvtUniqueId) {
                this.pvtUniqueId =
                    this.props.id ||
                        services_1.uniqueIdService.getId(this.constructor.name);
            }
            return this.pvtUniqueId;
        },
        enumerable: false,
        configurable: true
    });
    return GKPureComponent;
}(React.PureComponent));
exports.GKPureComponent = GKPureComponent;
/**
 * Combine incoming props with additional information.
 * @param props original properties to augment
 * @param options bag of new props to merge in as well as flags to drive behavior
 * @returns merged/augmented props
 */
var mapDefaultProps = function (props, options) {
    var _a = props, propId = _a.id, className = _a.className, qaProps = _a["data-qa"], style = _a.style, otherProps = __rest(_a, ["id", "className", "data-qa", "style"]);
    var result = __assign({ className: [options._gkComponentName, className, options.className]
            .filter(function (x) { return x; })
            .join(" "), "data-qa": options["data-qa"] || qaProps || options._gkComponentName, id: options.id ||
            propId ||
            (options.assignUniqueId ? services_1.uniqueIdService.getId() : undefined), style: style || options.style
            ? Object.assign({}, style, options.style)
            : undefined }, otherProps);
    return result;
};
exports.mapDefaultProps = mapDefaultProps;
